<app-navbar></app-navbar>
<div class="container py-5">
  <div class="row">
    <div class="col-md-6 d-none d-md-block ilustracion">
      <!-- Aquí puedes insertar una imagen SVG o componente visual -->
    </div>

    <div class="col-md-6">
      <h2 class="mb-3">{{ 'REGISTER.TITLE' | translate }}</h2>
      <p class="mb-4 text-muted">{{ 'REGISTER.DESCRIPTION' | translate }}</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'REGISTER.NAME_LABEL' | translate }}</mat-label>
              <input matInput formControlName="name" required>
              @if (form.get('name')?.invalid) {
              <mat-error>{{ 'REGISTER.REQUIRED_ERROR' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'REGISTER.LAST_NAME_LABEL' | translate }}</mat-label>
              <input matInput formControlName="lastName" required>
              @if (form.get('lastName')?.invalid) {
              <mat-error>{{ 'REGISTER.REQUIRED_ERROR' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'REGISTER.EMAIL_LABEL' | translate }}</mat-label>
          <input matInput formControlName="email" type="email" placeholder="{{ 'REGISTER.EMAIL_PLACEHOLDER' | translate }}" required>
          @if (form.get('email')?.invalid) {
          <mat-error>{{ 'REGISTER.EMAIL_INVALID_ERROR' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'REGISTER.PHONE_LABEL' | translate }}</mat-label>
          <input matInput formControlName="phone">
          @if (form.get('phone')?.invalid) {
          <mat-error>{{ 'REGISTER.REQUIRED_ERROR' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'REGISTER.ID_NUMBER_LABEL' | translate }}</mat-label>
          <input matInput formControlName="idNumber" required>
          @if (form.get('idNumber')?.invalid) {
          <mat-error>{{ 'REGISTER.REQUIRED_ERROR' | translate }}</mat-error>
          }
        </mat-form-field>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'REGISTER.PASSWORD_LABEL' | translate }}</mat-label>
              <input matInput formControlName="password" [type]="mostrarPassword ? 'text' : 'password'" required>
              @if (!mostrarPassword) {
              <mat-icon matSuffix (click)="mostrarPassword = !mostrarPassword"> visibility_off </mat-icon>
              }
              @if (mostrarPassword) {
              <mat-icon matSuffix (click)="mostrarPassword = !mostrarPassword"> visibility </mat-icon>
              }
              @if (form.get('password')?.invalid) {
              <mat-error>{{ 'REGISTER.PASSWORD_MIN_LENGTH_ERROR' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'REGISTER.CONFIRM_PASSWORD_LABEL' | translate }}</mat-label>
              <input matInput formControlName="confirm" [type]="mostrarConfirm ? 'text' : 'password'" required>
              @if (!mostrarConfirm) {
              <mat-icon matSuffix (click)="mostrarConfirm = !mostrarConfirm"> visibility_off </mat-icon>
              }
              @if (mostrarConfirm) {
              <mat-icon matSuffix (click)="mostrarConfirm = !mostrarConfirm"> visibility </mat-icon>
              }
              @if (form.get('confirm')?.invalid) {
              <mat-error>{{ 'REGISTER.PASSWORD_MISMATCH_ERROR' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        @if (form.hasError('passwordMismatch') && form.get('confirm')?.touched) {
        <div class="text-danger small mb-2">
          {{ 'REGISTER.PASSWORD_MISMATCH_ERROR' | translate }}
        </div>
        }

        <div class="row">
          <label>
            <input type="checkbox" formControlName="acceptEmailUpdate" [(ngModel)]="acceptEmailUpdate" 
          title="{{'REGISTER.SEND_MAIL_UPDATE' | translate }}" >
          {{'REGISTER.SEND_MAIL_UPDATE' | translate }}
          </label>                 
      </div>

        <button mat-raised-button color="accent" class="w-100 mt-3" type="submit" [disabled]="form.invalid">
          {{ 'REGISTER.SUBMIT_BUTTON' | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
<app-footer></app-footer>